import ServicePage from "../Common/ServicePage";

// Tap Installation specific services
const tapInstallationServices = [
  { 
    id: 1, 
    name: 'Standard Tap Installation', 
    provider: 'TapPro Experts', 
    image: 'https://placehold.co/600x400?text=Standard+Tap+Install', 
    rating: 4.75, 
    reviews: 400, 
    price: 200, 
    category: 'Standard Installation' 
  },
  { 
    id: 2, 
    name: 'Premium Tap Installation', 
    provider: 'EliteTap Professionals', 
    image: 'https://placehold.co/600x400?text=Premium+Tap+Install', 
    rating: 4.85, 
    reviews: 300, 
    price: 400, 
    category: 'Premium Installation' 
  },
  { 
    id: 3, 
    name: 'Tap Replacement Service', 
    provider: 'TapReplace Solutions', 
    image: 'https://placehold.co/600x400?text=Tap+Replacement', 
    rating: 4.78, 
    reviews: 350, 
    price: 150, 
    category: 'Replacement' 
  },
  { 
    id: 4, 
    name: 'Mixer Tap Installation', 
    provider: 'MixerTap Specialists', 
    image: 'https://placehold.co/600x400?text=Mixer+Tap+Install', 
    rating: 4.82, 
    reviews: 280, 
    price: 250, 
    category: 'Mixer Tap' 
  },
  { 
    id: 5, 
    name: 'Wall-Mounted Tap Installation', 
    provider: 'WallTap Experts', 
    image: 'https://placehold.co/600x400?text=Wall+Mounted+Tap', 
    rating: 4.80, 
    reviews: 220, 
    price: 350, 
    category: 'Wall-Mounted' 
  },
  { 
    id: 6, 
    name: 'Sensor Tap Installation', 
    provider: 'SensorTap Professionals', 
    image: 'https://placehold.co/600x400?text=Sensor+Tap+Install', 
    rating: 4.86, 
    reviews: 180, 
    price: 600, 
    category: 'Sensor Tap' 
  },
  { 
    id: 7, 
    name: 'Kitchen Tap Installation', 
    provider: 'KitchenTap Solutions', 
    image: 'https://placehold.co/600x400?text=Kitchen+Tap+Install', 
    rating: 4.79, 
    reviews: 320, 
    price: 220, 
    category: 'Kitchen Tap' 
  },
  { 
    id: 8, 
    name: 'Bathroom Tap Installation', 
    provider: 'BathTap Experts', 
    image: 'https://placehold.co/600x400?text=Bathroom+Tap+Install', 
    rating: 4.83, 
    reviews: 290, 
    price: 200, 
    category: 'Bathroom Tap' 
  },
  { 
    id: 9, 
    name: 'Outdoor Tap Installation', 
    provider: 'OutdoorTap Professionals', 
    image: 'https://placehold.co/600x400?text=Outdoor+Tap+Install', 
    rating: 4.77, 
    reviews: 150, 
    price: 280, 
    category: 'Outdoor Tap' 
  },
  { 
    id: 10, 
    name: 'Hot & Cold Tap Installation', 
    provider: 'HotColdTap Solutions', 
    image: 'https://placehold.co/600x400?text=Hot+Cold+Tap', 
    rating: 4.84, 
    reviews: 240, 
    price: 320, 
    category: 'Hot & Cold' 
  },
  { 
    id: 11, 
    name: 'Water Filter Tap Installation', 
    provider: 'FilterTap Experts', 
    image: 'https://placehold.co/600x400?text=Filter+Tap+Install', 
    rating: 4.81, 
    reviews: 200, 
    price: 380, 
    category: 'Filter Tap' 
  },
  { 
    id: 12, 
    name: 'Tap Washer Replacement', 
    provider: 'WasherPro Services', 
    image: 'https://placehold.co/600x400?text=Tap+Washer+Replace', 
    rating: 4.75, 
    reviews: 270, 
    price: 80, 
    category: 'Washer Replacement' 
  },
  { 
    id: 13, 
    name: 'Tap Dripping Repair', 
    provider: 'DripFix Professionals', 
    image: 'https://placehold.co/600x400?text=Tap+Dripping+Repair', 
    rating: 4.82, 
    reviews: 330, 
    price: 120, 
    category: 'Dripping Repair' 
  },
  { 
    id: 14, 
    name: 'Emergency Tap Installation', 
    provider: 'EmergencyTap Services', 
    image: 'https://placehold.co/600x400?text=Emergency+Tap+Install', 
    rating: 4.88, 
    reviews: 160, 
    price: 500, 
    category: 'Emergency Service' 
  }
];

const tapInstallationCategories = ['Standard Installation', 'Premium Installation', 'Replacement', 'Mixer Tap', 'Wall-Mounted', 'Sensor Tap', 'Kitchen Tap', 'Bathroom Tap', 'Outdoor Tap', 'Hot & Cold', 'Filter Tap', 'Washer Replacement', 'Dripping Repair', 'Emergency Service'];

const packages = [
  { id: 1, title: "Standard Tap Installation", rating: "4.75 (400 reviews)", price: 200, originalPrice: 250, icon: "🚰" },
  { id: 2, title: "Premium Tap Installation", rating: "4.85 (300 reviews)", price: 400, originalPrice: 500, icon: "💎" },
];

const miniServices = [
  { id: 101, title: "Tap Replacement", price: 150, icon: "🔧" },
  { id: 102, title: "Mixer Tap Installation", price: 250, icon: "🌡️" },
];

export default function TapInstallation() {
  return (
    <ServicePage
      serviceName="Tap Installation"
      packages={packages}
      miniServices={miniServices}
      customServices={tapInstallationServices}
      customCategories={tapInstallationCategories}
      isCustomService={true}
    />
  );
}